export const ROLE_KEYS = [
  "roleCoach",
  "roleManager",
  "roleBoardMember",
  "roleVolunteer",
  "roleParent",
  "roleOther",
] as const;

export const REFERRAL_KEYS = [
  "referralSearch",
  "referralSpondApp",
  "referralSocialMedia",
  "referralFriend",
  "referralEvent",
  "referralOther",
] as const;

export const ROLE_LABELS: Record<string, string> = {
  roleCoach: "Coach",
  roleManager: "Manager",
  roleBoardMember: "Board member",
  roleVolunteer: "Volunteer",
  roleParent: "Parent",
  roleOther: "Other",
};

export const REFERRAL_LABELS: Record<string, string> = {
  referralSearch: "Search engine",
  referralSpondApp: "The Spond App",
  referralSocialMedia: "Social media",
  referralFriend: "Friend / word of mouth",
  referralEvent: "Event / conference",
  referralOther: "Other",
};
